import { render, staticRenderFns } from "./UserAccountPasswordForm.vue?vue&type=template&id=6885d40f&"
import script from "./UserAccountPasswordForm.vue?vue&type=script&lang=js&"
export * from "./UserAccountPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports